import { render, staticRenderFns } from "./HeaderResults.vue?vue&type=template&id=90608054&"
import script from "./HeaderResults.vue?vue&type=script&lang=js&"
export * from "./HeaderResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports